'use strict';

exports.__esModule = true;
exports.SearchBar = undefined;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _actionCreators = require('../store/action-creators');

var _filter = require('./row-items/filter');

var _filter2 = _interopRequireDefault(_filter);

var _input = require('./row-items/input');

var _input2 = _interopRequireDefault(_input);

var _submitButton = require('./row-items/submit-button');

var _submitButton2 = _interopRequireDefault(_submitButton);

var _index = require('./search-results/index');

var _index2 = _interopRequireDefault(_index);

var _backdrop = require('./backdrop');

var _backdrop2 = _interopRequireDefault(_backdrop);

var _searchBar = require('./search-bar.scss');

var _searchBar2 = _interopRequireDefault(_searchBar);

var _suggestionSource = require('../constants/suggestion-source');

var _suggestionSource2 = _interopRequireDefault(_suggestionSource);

var _filter3 = require('../constants/filter');

var _filter4 = _interopRequireDefault(_filter3);

var _filterInitial = require('../constants/filter-initial');

var _filterInitial2 = _interopRequireDefault(_filterInitial);

var _appsmartIdentity = require('../constants/appsmart-identity');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    config: _propTypes2.default.shape({
        hideOnEmpty: _propTypes2.default.bool,
        focusOnLoad: _propTypes2.default.bool,
        capabilities: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }).isRequired,
    onSearchQuery: _propTypes2.default.func.isRequired,
    onSearchMarketplace: _propTypes2.default.func,
    onSearchApps: _propTypes2.default.func,
    filterValue: _propTypes2.default.string.isRequired,
    searchQuery: _propTypes2.default.string.isRequired,
    marketplace: _propTypes2.default.array.isRequired,
    allResults: _propTypes2.default.array.isRequired,
    apps: _propTypes2.default.array.isRequired,
    showResults: _propTypes2.default.bool.isRequired,
    suggest: _propTypes2.default.array.isRequired,
    services: _propTypes2.default.array.isRequired,
    contentTypes: _propTypes2.default.array.isRequired,
    placeholder: _propTypes2.default.string.isRequired,
    setFilterValue: _propTypes2.default.func.isRequired,
    setSearchQuery: _propTypes2.default.func.isRequired,
    setShowResults: _propTypes2.default.func.isRequired,
    addToRecentQueries: _propTypes2.default.func.isRequired,
    capabilities: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    triggerSearch: _propTypes2.default.func.isRequired,
    autocompleteHint: _propTypes2.default.string
};

var defaultProps = {
    onSearchMarketplace: function onSearchMarketplace(_ref) {
        var detail = _ref.detail;

        location.href = 'https://marketplace.appdirect.com/listing?q=' + encodeURIComponent(detail);
    },
    onSearchApps: function onSearchApps(_ref2) {
        var detail = _ref2.detail;

        location.href = 'https://appwise.appdirect.com/beta/search/' + encodeURIComponent(detail);
    },
    autocompleteHint: ''
};

var isfilterDisplayed = function isfilterDisplayed(capabilities) {
    var filterValues = void 0;
    if (capabilities.length) {
        filterValues = Object.values(_filter4.default);
    } else {
        filterValues = Object.values(_filterInitial2.default);
    }

    return filterValues.length > 1;
};

var SearchBar = exports.SearchBar = function (_React$Component) {
    _inherits(SearchBar, _React$Component);

    function SearchBar(props) {
        _classCallCheck(this, SearchBar);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.onSearch = _this.onSearch.bind(_this);
        _this.onSetFilterValue = _this.onSetFilterValue.bind(_this);
        _this.handleClickBackdrop = _this.handleClickBackdrop.bind(_this);

        if ((0, _appsmartIdentity.isAppSmart)()) {
            _this.checkIfFilterValueProvided();
        }
        return _this;
    }

    SearchBar.prototype.onSearch = function onSearch(query) {
        this.searchInput.blur();
        this.props.setShowResults(false);
        this.props.triggerSearch(query);

        if (this.props.filterValue === _filter4.default.ALL) {
            this.props.addToRecentQueries(query);
        }
    };

    SearchBar.prototype.onSetFilterValue = function onSetFilterValue(value) {
        this.props.setFilterValue(value);
        this.searchInput.focus();
    };

    SearchBar.prototype.getCount = function getCount() {
        var _props = this.props,
            allResults = _props.allResults,
            apps = _props.apps,
            marketplace = _props.marketplace,
            suggest = _props.suggest,
            services = _props.services,
            contentTypes = _props.contentTypes;


        var count = allResults.length + suggest.length + apps.length + marketplace.length + services.length + contentTypes.length;

        return count;
    };

    SearchBar.prototype.checkIfFilterValueProvided = function checkIfFilterValueProvided() {
        var queryParams = window.location.href.split('?')[1];
        if (queryParams) {
            var productLine = _qs2.default.parse(queryParams, { ignoreQueryPrefix: true }).pl;

            // If multiple product lines are detected we pick the first in the group.
            // Advisors and Providers only belong to a single product line at the moment.
            if (Array.isArray(productLine)) {
                productLine = productLine[0];
            }

            var matchingFilter = (0, _appsmartIdentity.getMatchingProductLine)(productLine);
            if (matchingFilter) {
                this.props.setFilterValue(matchingFilter.filterValue);
            }
        }
    };

    SearchBar.prototype.handleClickBackdrop = function handleClickBackdrop() {
        this.props.setShowResults(false);
    };

    SearchBar.prototype.showResults = function showResults() {
        var _props2 = this.props,
            config = _props2.config,
            showResults = _props2.showResults;


        return showResults && (this.getCount() > 0 || !config.hideOnEmpty);
    };

    SearchBar.prototype.render = function render() {
        var _this2 = this;

        var _props3 = this.props,
            config = _props3.config,
            filterValue = _props3.filterValue,
            searchQuery = _props3.searchQuery,
            showResults = _props3.showResults,
            capabilities = _props3.capabilities,
            allResults = _props3.allResults,
            marketplace = _props3.marketplace,
            apps = _props3.apps,
            suggest = _props3.suggest,
            placeholder = _props3.placeholder,
            services = _props3.services,
            contentTypes = _props3.contentTypes,
            autocompleteHint = _props3.autocompleteHint;

        // If capabilities is not set in props, use config.capabilities

        var resolvedCapabilities = capabilities && capabilities.length ? capabilities : config.capabilities;
        var filterDisplayed = isfilterDisplayed(resolvedCapabilities);

        return _react2.default.createElement(
            'div',
            { id: 'adsearch', className: (0, _classnames2.default)('adsearch-container', _searchBar2.default.mainContainer) },
            this.showResults() && _react2.default.createElement(_backdrop2.default, { onClick: this.handleClickBackdrop }),
            _react2.default.createElement(
                'div',
                { className: _searchBar2.default.container },
                _react2.default.createElement(_filter2.default, {
                    capabilities: resolvedCapabilities,
                    hideFilter: !filterDisplayed,
                    filterValue: filterValue,
                    setFilterValue: this.onSetFilterValue,
                    onOpen: this.handleClickBackdrop
                }),
                _react2.default.createElement(_input2.default, {
                    ref: function ref(n) {
                        _this2.searchInput = n;
                    },
                    searchQuery: searchQuery,
                    setSearchQuery: this.props.setSearchQuery,
                    showResults: showResults,
                    setShowResults: this.props.setShowResults,
                    filterDisplayed: filterDisplayed,
                    onSearch: this.onSearch,
                    placeholder: placeholder,
                    autocompleteHint: autocompleteHint,
                    focusOnLoad: config.focusOnLoad
                }),
                _react2.default.createElement(_submitButton2.default, {
                    onSearch: this.onSearch,
                    searchQuery: searchQuery
                })
            ),
            this.showResults() && _react2.default.createElement(_index2.default, {
                searchQuery: searchQuery,
                allResults: allResults,
                apps: apps,
                marketplace: marketplace,
                suggest: suggest,
                services: services,
                contentTypes: contentTypes,
                filterValue: filterValue,
                setSearchQuery: _actionCreators.setSearchQuery,
                onSearch: this.onSearch,
                count: this.getCount()
            })
        );
    };

    return SearchBar;
}(_react2.default.Component);

SearchBar.propTypes = propTypes;
SearchBar.defaultProps = defaultProps;

function mapStateToProps(state) {
    var MAX_SUGGESTION_DISPLAY_COUNT = 5;
    // This is assuming there are enough 'autocomplete' suggestions to fill the suggestions section.
    // If there are not enough 'autocomplete' suggestions, then the number of recent queries shown
    // can be more than the number specified here.
    var MAX_RECENT_QUERY_DISPLAY_COUNT = 2;
    var savedQuery = state.savedQuery || '';

    // This will be sliced further, depending on the number of 'autocomplete' suggestions.
    var recentQueries = state.recentQueries.filter(function (item) {
        return item && item.trim().toLowerCase().startsWith(savedQuery.trim().toLowerCase());
    }).slice(0, MAX_SUGGESTION_DISPLAY_COUNT).map(function (item) {
        return {
            source: _suggestionSource2.default.RECENT,
            label: item
        };
    });

    var guaranteedRecentQueryLabels = state.recentQueries.filter(function (item) {
        return item && item.trim().toLowerCase().startsWith(savedQuery.trim().toLowerCase());
    }).slice(0, MAX_RECENT_QUERY_DISPLAY_COUNT).map(function (recentQuery) {
        return recentQuery.trim().toLowerCase();
    });

    var autocompleteSuggestions = state.autocompleteTerms.slice(0, MAX_SUGGESTION_DISPLAY_COUNT).map(function (item) {
        return {
            source: _suggestionSource2.default.AUTOCOMPLETE,
            label: item
        };
    })
    // Filter out 'autocomplete' suggestions that are duplicates of recent queries guaranteed to be shown in the
    // suggestions section. This ensures that if a suggested item is both a recent query and an 'autocomplete'
    // suggestion, it is only shown once, as a recent query.
    .filter(function (item) {
        return typeof item.label === 'string' && !guaranteedRecentQueryLabels.includes(item.label.trim().toLowerCase());
    });

    var autocompleteDisplayCount = Math.min(MAX_RECENT_QUERY_DISPLAY_COUNT, recentQueries.length) + state.autocompleteTerms.length > MAX_SUGGESTION_DISPLAY_COUNT ? MAX_SUGGESTION_DISPLAY_COUNT - Math.min(MAX_RECENT_QUERY_DISPLAY_COUNT, recentQueries.length) : state.autocompleteTerms.length;

    // Consists of recent queries and autocomplete suggestions
    var suggestions = [];
    suggestions.push.apply(suggestions, recentQueries.slice(0, MAX_SUGGESTION_DISPLAY_COUNT - autocompleteDisplayCount));
    suggestions.push.apply(suggestions, autocompleteSuggestions.slice(0, autocompleteDisplayCount));

    return {
        filterValue: state.filterValue,
        searchQuery: state.searchQuery,
        marketplace: state.marketplace,
        allResults: state.allResults,
        apps: state.apps,
        showResults: state.showResults,
        suggest: suggestions,
        services: state.services,
        contentTypes: state.contentTypes,
        capabilities: state.capabilities,
        // Use first item from suggestions as the autocomplete hint
        autocompleteHint: state.filterValue === _filter4.default.ALL ? suggestions.map(function (item) {
            return item.label;
        }).find(function (value) {
            return typeof value === 'string' && value.toLowerCase().startsWith(savedQuery);
        }) : null
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return Object.assign({}, (0, _redux.bindActionCreators)({
        setFilterValue: _actionCreators.setFilterValue,
        setSearchQuery: _actionCreators.setSearchQuery,
        setShowResults: _actionCreators.setShowResults,
        addToRecentQueries: _actionCreators.addToRecentQueries
    }, dispatch), {
        triggerSearch: function triggerSearch(query) {
            dispatch((0, _actionCreators.executeSearch)(query, {
                onSearchQuery: ownProps.onSearchQuery,
                onSearchApps: ownProps.onSearchApps,
                onSearchMarketplace: ownProps.onSearchMarketplace
            }));
        }
    });
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchBar);